import React from "react";
import Graph from "./Graph";
import Paths from "./Paths";

const CareerPath = ({ resultOverride }) => {
  return (
   <>
    <Graph resultOverride={resultOverride} />
    <Paths />
   </>
  );
};

export default CareerPath;
